import { render, staticRenderFns } from "./InternalNotifications.vue?vue&type=template&id=5715a820"
import script from "./InternalNotifications.vue?vue&type=script&lang=js"
export * from "./InternalNotifications.vue?vue&type=script&lang=js"
import style0 from "./InternalNotifications.vue?vue&type=style&index=0&id=5715a820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports